<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]" class="container-im-2-1">
    <img id="arbre" class="character" width="600" src="https://cdn.exploreve.fr/content/IM2/Arbre.svg" />
    <img id="erwin" class="character" width="130" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" />
    <img id="daria" class="character" width="350" src="https://cdn.exploreve.fr/content/personnages/daria.svg" />
    <img id="leon" class="character" width="250" src="https://cdn.exploreve.fr/content/personnages/leon.svg" />
    <div id="ellipse-1" class="ellipse"></div>
    <div id="ellipse-2" class="ellipse"></div>
    <div id="ellipse-3" class="ellipse"></div>

    <div class="img">
      <div class="cadre">
        <h3>Léon</h3>
        <audio controls>
          <source src="https://cdn.exploreve.fr/content/IM2/audio/LEON_intro.mp3" type="audio/mpeg" />
        </audio>
        <p>
          Si tu ne peux pas écouter,
          <a target="_blank" href="https://cdn.exploreve.fr/content/IM2/intro_leon.pdf">
            clique ici
          </a>
        </p>
      </div>
    </div>

    <div class="wrapper">
      <NextButton class="button" url="/immersion02/2" :text="'Commencer les recherches'" />
    </div>
    <div class="nuage n01"></div>
    <div class="nuage n02"></div>
    <div class="nuage n03"></div>
    <div class="nuage n04"></div>
    <div class="nuage n05"></div>
    <div class="nuage n06"></div>
    <div class="nuage n07"></div>
    <div class="nuage n08"></div>
  </div>
</template>

<script>
import NextButton from "@/components/NextButton.vue";
export default {
  name: "IM_2_0_1",
  data: function () {
    return {
      id: 1
    };
  },
  methods: {},
  components: {
    NextButton
  }
};
</script>

<style scoped lang="scss">
.container-im-2-1 {
  position: relative;
  max-width: 100vw;
  min-height: 90vh;
  overflow-x: hidden;
}
.button {
  position: absolute;
  bottom: 6vh;
  right: 13vw;
  z-index: 20;
}

p {
  font-size: 18px;
}

.img {
  position: absolute;
  top: 10%;
  left: 8%;
  z-index: 5;
}

.cadre {
  background-color: white;
  width: 350px;
  height: 200px;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.cadre::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 40px solid white;
}
img.character {
  z-index: 1;
  position: absolute;
}

img#arbre {
  top: -20%;
  right: -10%;
}
img#daria {
  bottom: 25%;
  right: 15%;
  transform: scaleX(-1);
}

img#erwin {
  bottom: 35%;
  right: 35%;
  transform: scaleX(-1);
}

img#leon {
  bottom: 12%;
  left: 35%;
}

div.ellipse {
  background: #fcedd9;
  border-radius: 50%;
  position: fixed;
  z-index: 0;
}

div.ellipse#ellipse-1 {
  width: 350px;
  height: 130px;
  top: 66%;
  right: 12%;
}

div.ellipse#ellipse-2 {
  width: 280px;
  height: 100px;
  top: 60%;
  right: 29%;
}
div.ellipse#ellipse-3 {
  width: 280px;
  height: 100px;
  top: 78%;
  left: 33%;
}

.nuage {
  position: absolute;
  background-color: $light;
  opacity: 0.7;
}

@keyframes float {
  from {
    margin-top: 0;
  }
  to {
    margin-top: 20px;
  }
}

$animation-duration: 3s;

.n01 {
  top: 10%;
  right: 2%;
  width: 750px;
  height: 121px;
  border-radius: 60px;
  z-index: 0;
  animation: float $animation-duration infinite alternate ease-in-out;
}

.n02 {
  top: 5%;
  left: 20%;
  width: 197px;
  height: 33px;
  border-radius: 15px;
  z-index: 0;
  animation: float $animation-duration 4s infinite alternate ease-in-out;
}

.n03 {
  top: 28%;
  left: -5%;
  width: 800px;
  height: 100px;
  border-radius: 72px;
  z-index: 0;
  animation: float $animation-duration 1s infinite alternate ease-in-out;
}

.n04 {
  top: 35%;
  right: -2%;
  width: 430px;
  height: 50px;
  border-radius: 31px;
  z-index: 1;
  animation: float $animation-duration 6s infinite alternate ease-in-out;
}

.n05 {
  top: 50%;
  left: -5%;
  width: 400px;
  height: 50px;
  border-radius: 72px;
  z-index: 0;
  animation: float $animation-duration 5s infinite alternate ease-in-out;
}

.n06 {
  top: 45%;
  right: 32%;
  width: 426px;
  height: 50px;
  border-radius: 72px;
  z-index: 1;
  animation: float $animation-duration 2s infinite alternate ease-in-out;
}

.n07 {
  top: 63%;
  left: 25%;
  width: 317px;
  height: 65px;
  border-radius: 31px;
  z-index: 1;
  animation: float $animation-duration 7s infinite alternate ease-in-out;
}

.n08 {
  top: 60%;
  right: -5%;
  width: 617px;
  height: 75px;
  border-radius: 60px;
  z-index: 1;
  animation: float $animation-duration 3s infinite alternate ease-in-out;
}
</style>
